<template>
  <div>
    <slotBase :bg-grey="true">
      <template v-slot:title>
        <titleBar :header-title="'pageOne'" />
      </template>
      <template v-slot:content>
        <div class="text-center p-t-20">
          <p class="f-Overpass f-w-600 f-20">
            This is Page Example , Before you start
          </p>
          <div class="d-flex justify-content-md-evenly">
            <button class="btn btn-outline-primary" @click="routeTo">
              navigate
            </button>
            <button class="btn btn-outline-secondary" @click="openModal">
              open modal
            </button>
          </div>
        </div>
      </template>
      <template v-slot:modal>
        <modalExample ref="modalExample" />
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import modalExample from "../components/modal/modalExample.vue";

export default {
  name: "pageOne",
  components: {
    slotBase,
    titleBar,
    modalExample,
  },
  methods: {
    routeTo() {
      this.$router.push({ name: "pageTwo" });
    },

    openModal() {
      this.$refs.modalExample.open();
    },
  },
};
</script>
